import React from "react";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import "./home-page.css";

export default function CookiePolicy() {
  return (
    <div className="home-pro">
      <SEO
        title="Cookie Policy | QrMenu Italia"
        description="Informativa sull'utilizzo dei cookie nel sito QrMenu Italia."
        canonical="https://qrmenu-italia.it/cookie-policy"
        image="https://qrmenu-italia.it/logo512.png"
        keywords="cookie policy qrmenu, cookie qrmenu italia"
      />

      <MarketingNavbar />

      <section
        className="hp-final"
        style={{
          minHeight: "100vh",
          paddingTop: "140px",
          paddingBottom: "80px",
        }}
      >
        <div
          className="hp-final-inner"
          style={{
            maxWidth: "900px",
            textAlign: "left",
          }}
        >
          <h1 className="hp-final-h2">Cookie Policy</h1>

          <p className="hp-final-sub">
            Informazioni sull'utilizzo dei cookie e degli strumenti di analisi
            nel sito QrMenu Italia.
          </p>

          <div
            style={{
              marginTop: "40px",
              lineHeight: "1.8",
            }}
          >
            <h2>1. Cosa sono i cookie</h2>

            <p>
              I cookie sono piccoli file o informazioni che possono essere
              memorizzati sul dispositivo dell'utente durante la navigazione di
              un sito web.
            </p>

            <p>
              Possono essere utilizzati per consentire il corretto
              funzionamento del sito, ricordare determinate preferenze o
              raccogliere informazioni statistiche sull'utilizzo del servizio.
            </p>

            <h2>2. Cookie e strumenti necessari</h2>

            <p>
              QrMenu Italia utilizza tecnologie necessarie al funzionamento
              tecnico del sito e della piattaforma. Tali strumenti possono
              essere necessari, ad esempio, per garantire il funzionamento
              delle funzionalità richieste dall'utente, la sicurezza e la
              memorizzazione di alcune preferenze.
            </p>

            <h2>3. Cookie e strumenti di analisi</h2>

            <p>
              QrMenu Italia può utilizzare Google Analytics per ottenere
              informazioni statistiche relative all'utilizzo delle pagine
              pubbliche del sito.
            </p>

            <p>
              Nel sito QrMenu Italia gli strumenti di analisi vengono attivati
              secondo la scelta espressa dall'utente attraverso il banner di
              gestione dei cookie.
            </p>

            <p>
              L'utente può accettare tutti i cookie facoltativi, rifiutarli
              oppure personalizzare le proprie preferenze.
            </p>

            <h2>4. Scelta dell'utente</h2>

            <p>
              Al primo accesso alle pagine pubbliche di QrMenu Italia viene
              mostrato un pannello che consente di scegliere se autorizzare o
              meno l'utilizzo degli strumenti di analisi.
            </p>

            <p>
              La preferenza espressa viene memorizzata localmente nel browser
              utilizzato dall'utente.
            </p>

            <h2>5. Modifica delle preferenze</h2>

            <p>
              L'utente può cancellare i dati di navigazione o le preferenze
              memorizzate nel proprio browser e, alla successiva visita, potrà
              effettuare nuovamente la scelta.
            </p>

            <h2>6. Gestione dei cookie tramite browser</h2>

            <p>
              La maggior parte dei browser consente di visualizzare,
              cancellare, limitare o bloccare i cookie attraverso le proprie
              impostazioni.
            </p>

            <p>
              La disabilitazione di alcuni strumenti tecnici potrebbe
              influire sul corretto funzionamento di alcune funzionalità del
              servizio.
            </p>

            <h2>7. Titolare del trattamento</h2>

            <p>
              Il titolare del trattamento è:
            </p>

            <p>
              <strong>Michelangelo Candiano</strong>
              <br />
              Email:{" "}
              <a href="mailto:info@qrmenu-italia.it">
                info@qrmenu-italia.it
              </a>
            </p>

            <h2>8. Ulteriori informazioni</h2>

            <p>
              Per maggiori informazioni sul trattamento dei dati personali è
              possibile consultare la Privacy Policy di QrMenu Italia.
            </p>

            <p>
              <strong>Ultimo aggiornamento: luglio 2026.</strong>
            </p>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}